import React from 'react'

const React_Coding_Practice_5 = () => {
  return (
    <div>
      <h1>Coding Pratice 5</h1>
    </div>
  )
}

export default React_Coding_Practice_5
